import { Actions } from 'vuex-smart-module';
import { Reports } from '@/modules/reports/types';
import { ReportsService } from '@/modules/reports/services';
import ReportsMutualsGetters from './getters';
import ReportsMutualsMutations from './mutations';
import ReportsMutualsState from './state';

const reportsService = new ReportsService();

export default class ReportsMutualsActions extends Actions<
  ReportsMutualsState,
  ReportsMutualsGetters,
  ReportsMutualsMutations,
  ReportsMutualsActions
> {
  async get_mutuals_reports() {
    try {
      const filtersEmpty = Boolean(this.state.organizations.length && this.state.external_organizations.length && this.state.contracts.length);

      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const { is_download } = this.state;
      const payload: Reports.MutualRequest = {
        filters: this.state.filters,
        filters_exist: filtersEmpty,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      if (!this.state.is_download) {
        this.mutations.TOGGLE_LOADING(true);
        this.mutations.TOGGLE_IS_DOWNLOAD_LOADING(false);
      } else {
        this.mutations.TOGGLE_IS_DOWNLOAD_LOADING(true);
      }

      const { data, meta } = await reportsService.get_mutuals_reports(payload, is_download);

      if (!filtersEmpty) {
        this.mutations.SET_ORGANIZATIONS(data.filters.organizations);
        this.mutations.SET_EXTERNAL_ORGANIZATION(data.filters.external_organizations);
        this.mutations.SET_CONTRACTS(data.filters.contracts);
      }

      this.mutations.SET_MUTUALS(data.items);
      this.mutations.SET_DEBT_INFO(data.total);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING(false);
      this.mutations.TOGGLE_IS_DOWNLOAD_LOADING(false);
    }
  }
}
